class FlashMessage extends HTMLElement {
  connectedCallback() {
    setTimeout(this.show, 150)
    setTimeout(this.hide, 3000)
  }

  show = () => {
    this.style.setProperty('bottom', 'var(--flash-show-position)')
    this.style.setProperty('opacity', '100%')
  }

  hide = () => {
    this.style.setProperty('bottom', 'var(--flash-hide-position)')
    this.style.setProperty('opacity', '0%')
    setTimeout(this.destroy, 500)
  }

  destroy = () => {
    this.remove()
  }
}

class FlashNoticeElement extends FlashMessage {}
class FlashErrorElement extends FlashMessage {}

customElements.define("flash-notice", FlashNoticeElement);
customElements.define("flash-error", FlashErrorElement);

function flash(type, message) {
  const flashElement = document.createElement(`flash-${type}`)
  flashElement.textContent = message
  document.body.appendChild(flashElement)
}
function flashNotice(message) { flash('notice', message) }
function flashError(message) { flash('error', message) }



export { flashNotice, flashError }
